import styled from 'styled-components';

export const Tabela = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-bottom: 12px;
`;

export const Menus = styled.div`
  display: flex;
  flex: 1;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;

  svg {
    font-size: 26px;
    color: #fff;
  }

  ul {
    list-style: none;
    display: grid;
    width: 100%;
    /* aqui eu determino é são 3 colunas de tamanhos iguas, cada coluna tem uma fração */
    grid-template-columns: repeat(13, 1fr);
    /* esssa é a altura das linhas, se vc quiser pode apaga-la caso não queira uma altura definida */
    grid-auto-rows: auto;
    /* espaço entre um elemento interno e outro */
    grid-gap: 5px 8px;
    /* margem interna que afasta os elementos da borda do grid */
    text-align: center;
  }

  ul li button {
    width: 100%;
    border: none;
    height: 56px;
    border-radius: 5px;
    padding-left: 4px;
    padding-right: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background: #0f73af;

    &:hover {
      background: #2a9fe5;
    }
  }

  .active {
    background: #2a9fe5;
  }
`;
